import { GrowthBook } from '@growthbook/growthbook';
import { TenantDto } from '@nusign/picflow-backend-types';

export const isTenantBlocked = (tenant: TenantDto, growthBook: GrowthBook) => {
  if (!tenant) return false;
  const attributes = growthBook.getAttributes();
  growthBook.setAttributes({
    ...attributes,
    tenantId: tenant.id,
  });

  const isBlocked = growthBook.isOn('blocked-tenants');
  growthBook.setAttributes({
    ...attributes,
  });
  return isBlocked;
};
